import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Approved from './Approved';
import LoginNIFPage from './LoginNIFPage';
import Step1 from './Step1';
import ViewPDF from './ViewPDF';
import EmailPDF from './EmailPDF';
import EmailPDFSent from './EmailPDFSent';
import Privacy from './Privacy';
import Init from './Init';

const App = () => {
	useEffect(() => {
		console.log(process.env.NODE_ENV);
		localStorage.setItem("push", "0");
	}, []);

	return (
		<Router>
			<Routes>
				<Route path="/" element={<Init />} />
				<Route path="/:lead_id" element={<Init />} />
				<Route path="/onboarding" element={<Step1 />} />
				<Route path="/onboarding/nif" element={<LoginNIFPage />} />
				<Route path="/onboarding/approved" element={<Approved />} />
				<Route path="/onboarding/view-pdf/:lead_id" element={<ViewPDF />} />
				<Route path="/onboarding/email" element={<EmailPDF />} />
				<Route path="/onboarding/email/sent" element={<EmailPDFSent />} />
				<Route path="/privacy" element={<Privacy />} />
			</Routes>
		</Router>
	);
};

export default App;